var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profileImage?.fullUri)?_c('img',{attrs:{"height":_vm.size,"src":_vm.profileImage.fullUri,"width":_vm.size,"alt":"Avatar"}}):_c('span',{staticClass:"white--text",style:(`font-size: ${_vm.size * 0.53}px`),domProps:{"textContent":_vm._s(`${_vm.firstName.charAt(0)}${_vm.lastName.charAt(0)}`)}})
}
var staticRenderFns = []

export { render, staticRenderFns }